import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AutoStoriesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"auto_stories"}/>
}
